/**
 * Open mobile-nav
 */
const $mobileNav = $(".js-mobile-nav");
const $nav = $(".js-nav > ul");
const $link = $nav.find("li a + img");
const $window = $(window);
const $body = $("body");
const $header = $(".header");

$mobileNav.on("click", function () {
  const $this = $(this);

  $this.toggleClass("mobile-nav--active");
  $header.toggleClass("is-active");
  $body.toggleClass("is-fixed");
});

/**
 * Dropdown.
 *
 */

$(document).on("click", ".js-nav > ul li a + img", function (e) {
  const $this = $(this);
  const $dropdown = $this.siblings();
  const $closeDropdown = $dropdown.find(".close-dropdown");

  $closeDropdown.css("opacity", 1);

  if ($window.width() <= 1023) {
    $dropdown.toggleClass("is-active");

    $closeDropdown.on("click", function () {
      $dropdown.removeClass("is-active");
      $closeDropdown.css("opacity", 0);
    });
  }
});

